import Vue from 'vue'
import Router from 'vue-router'

/* LOGIN */
import TheB2bLogin from '@/views/login/TheB2bLogin'
import B2bLoginB2BForm from '@/components/loginb2b/B2bLoginB2BForm'
import B2bLoginB2BPasswordForm from '@/components/loginb2b/B2bLoginB2BPasswordForm'
import B2bChangePassword from '@/components/logingeneric/B2bChangePassword'
import B2bTwoFactorAuthForm from '@/components/loginb2b/B2bTwoFactorAuthB2BForm'

/* QUIRON */
import B2bLoginFormQuiron from '@/components/loginquiron/B2bLoginFormQuiron'
import B2bLoginPasswordFormQuiron from '@/components/loginquiron/B2bLoginPasswordFormQuiron'

/* HIPOGES */
import B2bLoginFormHipoges from '@/components/loginhipoges/B2bLoginFormHipoges'
import B2bLoginPasswordFormHipoges from '@/components/loginhipoges/B2bLoginPasswordFormHipoges'

/* OHL */
import B2bLoginFormOhl from '@/components/loginohl/B2bLoginFormOhl'
import B2bLoginPasswordFormOhl from '@/components/loginohl/B2bLoginPasswordFormOhl'

/* RENFE */
import B2bLoginFormRenfe from '@/components/loginrenfe/B2bLoginFormRenfe'
import B2bLoginPasswordFormRenfe from '@/components/loginrenfe/B2bLoginPasswordFormRenfe'

/* UFGAS */
import B2bLoginFormUfgas from '@/components/loginufgas/B2bLoginFormUfgas'
import B2bLoginPasswordFormUfgas from '@/components/loginufgas/B2bLoginPasswordFormUfgas'

/* REE */
import B2bLoginFormRee from '@/components/loginree/B2bLoginFormRee'
import B2bLoginPasswordFormRee from '@/components/loginree/B2bLoginPasswordFormRee'

/* CANAL */
import B2bLoginFormCanal from '@/components/logincanal/B2bLoginFormCanal'
import B2bLoginPasswordFormCanal from '@/components/logincanal/B2bLoginPasswordFormCanal'

/* LYNTIA */
import B2bLoginFormLyntia from '@/components/loginlyntia/B2bLoginFormLyntia'
import B2bLoginPasswordFormLyntia from '@/components/loginlyntia/B2bLoginPasswordFormLyntia'

/* CORREOS */
import B2bLoginFormCorreos from '@/components/logincorreos/B2bLoginFormCorreos'
import B2bLoginPasswordFormCorreos from '@/components/logincorreos/B2bLoginPasswordFormCorreos'

/* VOCENTO */
import B2bLoginFormVocento from '@/components/loginvocento/B2bLoginFormVocento'
import B2bLoginPasswordFormVocento from '@/components/loginvocento/B2bLoginPasswordFormVocento'

/* RED.ES */
import B2bLoginFormRedes from '@/components/loginredes/B2bLoginFormRedes'
import B2bLoginPasswordFormRedes from '@/components/loginredes/B2bLoginPasswordFormRedes'

/* TEE */
import B2bLoginFormTee from '@/components/logintee/B2bLoginFormTee'
import B2bLoginPasswordFormTee from '@/components/logintee/B2bLoginPasswordFormTee'

/* ACCIONA ENERGIA */
import B2bLoginFormAccionaEnergia from '@/components/loginaccionaenergia/B2bLoginFormAccionaEnergia'
import B2bLoginPasswordFormAccionaEnergia from '@/components/loginaccionaenergia/B2bLoginPasswordFormAccionaEnergia'

/* APP */
import TheB2bApp from '@/views/TheB2bApp'
/* FACTURAS */
import B2bPageFacturas from '@/views/facturas/B2bPageFacturas'
import B2bPageFacturasEmitidas from '@/views/facturas/emitidas/B2bPageFacturasEmitidas'
import B2bTableFacturasEmitidas from '@/views/facturas/emitidas/B2bTableFacturasEmitidas'
import B2bPageFacturaEmitida from '@/views/facturas/emitidas/B2bPageFacturaEmitida'
import B2bPageFacturasRecibidas from '@/views/facturas/recibidas/B2bPageFacturasRecibidas'
import B2bTableFacturasRecibidas from '@/views/facturas/recibidas/B2bTableFacturasRecibidas'
import B2bPageFacturaRecibida from '@/views/facturas/recibidas/B2bPageFacturaRecibida'
import B2bPageBorradores from '@/views/facturas/borradores/B2bPageBorradores'
import B2bTableBorradores from '@/views/facturas/borradores/B2bTableBorradores'
import B2bPageBorrador from '@/views/facturas/borradores/B2bPageBorrador'
import B2bPageFacturasTerceros from '@/views/facturas/terceros/B2bPageFacturasTerceros'
import B2bPageConsultInvoiceByLink from '@/views/facturas/consultinvoicebylink/B2bPageConsultInvoiceByLink'
import B2bPageDownloadInvoice from '@/views/facturas/B2bPageDownloadInvoice.vue'

/* OCR - DOCUMENTOS PENDIENTES DE VALIDAR */
import B2bPageOcrDocuments from '@/views/facturas/ocrDocument/B2bPageOcrDocuments.vue'
import B2bTableOcrDocuments from '@/views/facturas/ocrDocument/B2bTableOcrDocuments.vue'
import B2bPageOcrDocument from '@/views/facturas/ocrDocument/B2bPageOcrDocument.vue'

/* TAREAS PENDIENTES */
import B2bPagePendingTask from '@/views/tareaspendientes/B2bPagePendingTask'
import B2bTablePendingTask from '@/views/tareaspendientes/B2bTablePendingTask'
import B2bPagePendingsTask from '@/views/tareaspendientes/B2bPagePendingsTask'
// Create cover
import B2bPageCreateCover from '@/views/tareaspendientes/createcover/B2bPageCreateCover'
/* AUDITORIAS */
import B2bPageAuditorias from '@/views/auditorias/B2bPageAuditorias'
/* Documentos */
import B2bPageAuditoriaDocumentos from '@/views/auditorias/documentos/B2bPageAuditoriaDocumentos'
import B2bPageAuditoriaDocumento from '@/views/auditorias/documentos/B2bPageAuditoriaDocumento'
import B2bTableAuditoriaDocumentos from '@/views/auditorias/documentos/B2bTableAuditoriaDocumentos'
/* Documentos */
import B2bPageAuditoriaAcciones from '@/views/auditorias/acciones/B2bPageAuditoriaAcciones'
import B2bTableAuditoriaAcciones from '@/views/auditorias/acciones/B2bTableAuditoriaAcciones'
/* ADMINISTRACION */
import B2bPageAdministracion from '@/views/administracion/B2bPageAdministracion'
/* SERVICIOS */
import B2bTableServicios from '@/views/administracion/servicios/B2bTableServicios'
import B2bPageAddServices from '@/views/administracion/servicios/B2bPageAddServices'
import B2bPageServicio from '@/views/administracion/servicios/B2bPageServicio'
/* SERVICIOS EMPRESAS */
import B2bTableServiciosEmpresas from '@/views/administracion/empresas/B2bTableServiciosEmpresas'
import B2bPagePartiesServices from '@/views/administracion/empresas/B2bPagePartiesServices'
import B2bPageAddPartiesServicesCountryNif from '@/views/administracion/empresas/B2bPageAddPartiesServicesCountryNif'
import B2bPageAddPartiesService from '@/views/administracion/empresas/B2bPageAddPartiesService'
/* RELACIONES COMERCIALES */
import B2bTableCommercialRelation from '@/views/administracion/empresas/relaciones/B2bTableCommercialRelation'
import B2bPageCommercialRelation from '@/views/administracion/empresas/relaciones/B2bPageCommercialRelation'

/* CENTROS */
import B2bTableCentres from '@/views/administracion/centros/B2bTableCentres'
import B2bPageCentres from '@/views/administracion/centros/B2bPageCentres'
import B2bPageAddCentre from '@/views/administracion/centros/B2bPageAddCentre'
import B2bPageApprovalFlowByLevels from '../views/administracion/centros/B2bPageApprovalFlowByLevels'
import B2bPageApprovalFlows from '../views/administracion/centros/B2bPageApprovalFlows'
/* USUARIOS */
import B2bPageUsuarios from '@/views/administracion/usuarios/B2bPageUsuarios'
import B2bPageUsuario from '@/views/administracion/usuarios/B2bPageUsuario'
import B2bTableUsuarios from '@/views/administracion/usuarios/B2bTableUsuarios'
/* PLANTILLAS DE CORREO */
// import B2bTablePlantillasDeCorreo from '@/views/administracion/plantillasDeCorreo/B2bTablePlantillasDeCorreo'
// import B2bPagePlantillaDeCorreo from '@/views/administracion/plantillasDeCorreo/B2bPagePlantillaDeCorreo'
/* PROCESOS PLANIFICADOS */
import B2bTablePlannedProcesses from '@/views/administracion/plannedProcesses/B2bTablePlannedProcesses'
import B2bPagePlannedProcesses from '@/views/administracion/plannedProcesses/B2bPagePlannedProcesses'
// Create user
//import B2bPageCreateUser from '@/views/administracion/usuarios/createuser/B2bPageCreateUser'
import B2bNewUser from '@/views/administracion/usuarios/createuser/B2bNewUser'
import B2bNewUserData from '@/views/administracion/usuarios/createuser/B2bNewUserData'
import B2bNewUserEntities from '@/views/administracion/usuarios/createuser/B2bNewUserEntities'
import B2bNewUserPermissions from '@/views/administracion/usuarios/createuser/B2bNewUserPermissions'
import B2bNewUserExistEntities from '@/views/administracion/usuarios/createuser/B2bNewUserExistEntities'
import B2bNewUserExistPermissions from '@/views/administracion/usuarios/createuser/B2bNewUserExistPermissions'
// Usuario exixtente
import B2bNewUserCif from '@/views/administracion/usuarios/createuser/B2bNewUserCif'
import B2bNewUserExistData from '@/views/administracion/usuarios/createuser/B2bNewUserExistData'
/* Perfiles */
import B2bTableProfiles from '@/views/administracion/profiles/B2bTableProfiles'
//import B2bPageProfile from '@/views/administracion/profiles/B2bPageProfile'
/* Impuestos */
import B2bTableTaxes from '@/views/administracion/taxes/B2bTableTaxes'
import B2bPageTax from '@/views/administracion/taxes/B2bPageTax'
/* Servidores de correo */
import B2bTableMailServers from '@/views/administracion/mailServer/B2bTableMailServer'
import B2bPageMailServer from '@/views/administracion/mailServer/B2bPageMailServer'
/* Incidencias */
import B2bPageIssues from '@/views/issues/B2bPageIssues'
import B2bPageIssue from '@/views/issues/B2bPageIssue'
import B2bTableIssues from '@/views/issues/B2bTableIssues'
/* RECEPCIONES */
import B2bPageRecepciones from '@/views/recepciones/B2bPageRecepciones'
/* RECEPCIONES EMITIDAS */
import B2bPageRecadvsEmit from '@/views/recepciones/emitidas/B2bPageRecadvsEmit'
import B2bTableRecadvsEmit from '@/views/recepciones/emitidas/B2bTableRecadvsEmit'
import B2bPageRecadvsEmits from '@/views/recepciones/emitidas/B2bPageRecadvsEmits'
/* RECEPCIONES RECIBIDAS */
import B2bPageRecadvsReceived from '@/views/recepciones/recibidas/B2bPageRecadvsReceived'
import B2bTableRecadvsReceived from '@/views/recepciones/recibidas/B2bTableRecadvsReceived'
import B2bPageRecadvsReceiveds from '@/views/recepciones/recibidas/B2bPageRecadvsReceiveds'
/* PEDIDOS */
import B2bPagePedidos from '@/views/pedidos/B2bPagePedidos'
/* PEDIDOS EMITIDOS */
import B2bPageOrdersEmit from '@/views/pedidos/emitidos/B2bPageOrdersEmit'
import B2bTableOrdersEmit from '@/views/pedidos/emitidos/B2bTableOrdersEmit'
import B2bPageOrdersEmits from '@/views/pedidos/emitidos/B2bPageOrdersEmits'
/* PEDIDOS RECIBIDOS */
import B2bPageOrdersReceived from '@/views/pedidos/recibidos/B2bPageOrdersReceived'
import B2bTableOrdersReceived from '@/views/pedidos/recibidos/B2bTableOrdersReceived'
import B2bPageOrdersReceiveds from '@/views/pedidos/recibidos/B2bPageOrdersReceiveds'

/* PROFILE */
// import B2bProfile from '@/views/profile/B2bProfile'
//import B2bProfileData from '@/views/profile/B2bProfileData'
import B2bProfilePassword from '@/views/profile/B2bProfilePassword'
import B2bProfileContact from '@/views/profile/B2bProfileContact'
import B2bProfileParties from '@/views/profile/B2bProfileParties'
import B2bPageProfileParties from '@/views/profile/B2bPageProfileParties'
//import B2bPagePartyInfo from '@/views/profile/B2bPagePartyInfo'
import B2bProfileSignature from '@/views/profile/B2bProfileSignature'

/* CIERRES CONTABLES */
import B2bPageCierresContables from '@/views/cierrescontables/B2bPageCierresContables'
import B2bTableCierresContables from '@/views/cierrescontables/B2bTableCierresContables'
/* BORRADORES CIERRES CONTABLES */
import B2bPageAccountingCloseDraft from '@/views/cierrescontablesborradores/B2bPageAccountingCloseDraft'
import B2bTableAccountingCloseDraft from '@/views/cierrescontablesborradores/B2bTableAccountingCloseDraft'
import B2bPageAccountingCloseDrafts from '@/views/cierrescontablesborradores/B2bPageAccountingCloseDrafts'
import B2bPageAddAccountingDraft from '@/views/cierrescontablesborradores/B2bPageAddAccountingDraft'
/* DOCUMENTACION */
import B2bPageDocumentacion from '@/views/documentacion/B2bPageDocumentacion'
import B2bPageDocumentacionDocumentos from '@/views/documentacion/documentos/B2bPageDocumentacionDocumentos'
import B2bPageDocumentacionDocumento from '@/views/documentacion/documentos/B2bPageDocumentacionDocumento'
import B2bTableDocumentacionDocumentos from '@/views/documentacion/documentos/B2bTableDocumentacionDocumentos'
/* ESTADISTICAS */
import B2bPageEstadisticas from '@/views/statistics/B2bPageEstadisticas'
import B2bPageEstadisticasEmitidas from '@/views/statistics/statisticsEmitted/B2bPageEstadisticasEmitidas'
import B2bPageEstadisticasRecibidas from '@/views/statistics/statisticsReceived/B2bPageEstadisticasRecibidas'
import B2bPageEstadisticasOtras from '@/views/statistics/statisticsOther/B2bPageEstadisticasOtras'
import B2bPageEstadisticasTopSeller from '@/views/statistics/statisticsTopSeller/B2bPageEstadisticasTopSeller'
import B2bPageEstadisticasEmpresas from '@/views/statistics/statisticsParties/B2bPageEstadisticasEmpresas'
import B2bPageEstadisticasRechazadas from '@/views/statistics/statisticsRejected/B2bPageEstadisticasRechazadas'
/* ALBARANES */
import B2bPageDeliveryNotes from '@/views/albaranes/B2bPageDeliveryNotes'
/* ALBARANES EMITIDOS */
import B2bPageDeliveryNotesEmit from '@/views/albaranes/emitidos/B2bPageDeliveryNotesEmit'
import B2bTableDeliveryNotesEmit from '@/views/albaranes/emitidos/B2bTableDeliveryNotesEmit'
import B2bPageDeliveryNotesEmits from '@/views/albaranes/emitidos/B2bPageDeliveryNotesEmits'
/* ALBARANES RECIBIDOS */
import B2bPageDeliveryNotesReceived from '@/views/albaranes/recibidos/B2bPageDeliveryNotesReceived'
import B2bTableDeliveryNotesReceived from '@/views/albaranes/recibidos/B2bTableDeliveryNotesReceived'
import B2bPageDeliveryNotesReceiveds from '@/views/albaranes/recibidos/B2bPageDeliveryNotesReceiveds'
import B2bRouterView from '@/components/B2bRouterView'


/* CMR */
import B2bPageCMR from '@/views/cmr/B2bPageCmr'

import B2bPageCMREmit from '@/views/cmr/emitidos/B2bPageCmrEmit'
import B2bTableCMR from '@/views/cmr/emitidos/B2bTableCmrEmit'
import B2bPageCMREmits from '@/views/cmr/emitidos/B2bPageCmrEmits'

/* GENRALS */
import B2bPageGenrals from '@/views/genrals/B2bPageGenrals'
/* GENRALS EMITIDOS */
import B2bPageGenralsEmit from '@/views/genrals/emitidos/B2bPageGenralsEmit'
import B2bTableGenralsEmit from '@/views/genrals/emitidos/B2bTableGenralsEmit'
import B2bPageGenralsEmits from '@/views/genrals/emitidos/B2bPageGenralsEmits'
/* GENRALS RECIBIDOS */
import B2bPageGenralsReceived from '@/views/genrals/recibidos/B2bPageGenralsReceived'
import B2bTableGenralsReceived from '@/views/genrals/recibidos/B2bTableGenralsReceived'
import B2bPageGenralsReceiveds from '@/views/genrals/recibidos/B2bPageGenralsReceiveds'

Vue.use(Router)

const route = new Router({
  base: '/einvoiceng',
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: TheB2bLogin,
      redirect: { name: 'login-form-b2b' },
      children: [
        {
          path: '',
          name: 'login-form-b2b',
          component: B2bLoginB2BForm
        },
        {
          path: 'new-password-form',
          name: 'new-password-form',
          component: B2bLoginB2BPasswordForm
        },        
        {
          path: 'password',
          name: 'change-password',
          component: B2bChangePassword,
          meta: {
            breadcrumbTextKey: 'profile_password'
          }
        },
        {
          path: '2fa',
          name: 'twoFactorAuth-form',
          component: B2bTwoFactorAuthForm
        }
      ]
    },
    {
      path: '/consultInvoiceByLink',
      name: 'consultInvoiceByLink',
      component: B2bPageConsultInvoiceByLink,
      meta: {
        breadcrumbTextKey: 'consult_invoice_bylink'
      }
    },
    {
      path: '/vocento/:action(download|detail)', // admite las rutas /vocento/download y /vocento/detail
      name: 'vocento',
      component: B2bPageDownloadInvoice,
      meta: {
        breadcrumbTextKey: 'consult_invoice_bylink'
      }
    },
    {
      path: '/ree',
      name: 'loginree',
      component: TheB2bLogin,
      redirect: { name: 'login-form-ree' },
      children: [
        {
          path: '',
          name: 'login-form-ree',
          component: B2bLoginFormRee
        },
        {
          path: 'new-password-form',
          name: 'new-password-ree',
          component: B2bLoginPasswordFormRee
        }
      ]
    },
    {
      path: '/quiron',
      name: 'loginquiron',
      component: TheB2bLogin,
      redirect: { name: 'login-form-quiron' },
      children: [
        {
          path: '',
          name: 'login-form-quiron',
          component: B2bLoginFormQuiron
        },
        {
          path: 'new-password-form',
          name: 'new-password-quiron',
          component: B2bLoginPasswordFormQuiron
        }
      ]
    },
    {
      path: '/hipoges',
      name: 'loginhipoges',
      component: TheB2bLogin,
      redirect: { name: 'login-form-hipoges' },
      children: [
        {
          path: '',
          name: 'login-form-hipoges',
          component: B2bLoginFormHipoges
        },
        {
          path: 'new-password-form',
          name: 'new-password-hipoges',
          component: B2bLoginPasswordFormHipoges
        }
      ]
    },
    {
      path: '/ohla',
      name: 'loginohl',
      component: TheB2bLogin,
      redirect: { name: 'login-form-ohl' },
      children: [
        {
          path: '',
          name: 'login-form-ohl',
          component: B2bLoginFormOhl
        },
        {
          path: 'new-password-form',
          name: 'new-password-ohl',
          component: B2bLoginPasswordFormOhl
        }
      ]
    },
    {
      path: '/renfe',
      name: 'loginrenfe',
      component: TheB2bLogin,
      redirect: { name: 'login-form-renfe' },
      children: [
        {
          path: '',
          name: 'login-form-renfe',
          component: B2bLoginFormRenfe
        },
        {
          path: 'new-password-form',
          name: 'new-password-renfe',
          component: B2bLoginPasswordFormRenfe
        }
      ]
    },
    {
      path: '/EECG',
      name: 'loginufgas',
      component: TheB2bLogin,
      redirect: { name: 'login-form-ufgas' },
      children: [
        {
          path: '',
          name: 'login-form-ufgas',
          component: B2bLoginFormUfgas
        },
        {
          path: 'new-password-form',
          name: 'new-password-ufgas',
          component: B2bLoginPasswordFormUfgas
        }
      ]
    },
    {
      path: '/CanalSA',
      name: 'logincanal',
      component: TheB2bLogin,
      redirect: { name: 'login-form-canal' },
      children: [
        {
          path: '',
          name: 'login-form-canal',
          component: B2bLoginFormCanal
        },
        {
          path: 'new-password-form',
          name: 'new-password-canal',
          component: B2bLoginPasswordFormCanal
        }
      ]
    },
    {
      path: '/lyntia',
      name: 'loginlyntia',
      component: TheB2bLogin,
      redirect: { name: 'login-form-lyntia' },
      children: [
        {
          path: '',
          name: 'login-form-lyntia',
          component: B2bLoginFormLyntia
        },
        {
          path: 'new-password-form',
          name: 'new-password-lyntia',
          component: B2bLoginPasswordFormLyntia
        }
      ]
    },
    {
      path: '/correosexpress',
      name: 'logincorreos',
      component: TheB2bLogin,
      redirect: { name: 'login-form-correos' },
      children: [
        {
          path: '',
          name: 'login-form-correos',
          component: B2bLoginFormCorreos
        },
        {
          path: 'new-password-form',
          name: 'new-password-correos',
          component: B2bLoginPasswordFormCorreos
        }
      ]
    },
    {
      path: '/telefonica',
      name: 'logintee',
      component: TheB2bLogin,
      redirect: { name: 'login-form-tee' },
      children: [
        {
          path: '',
          name: 'login-form-tee',
          component: B2bLoginFormTee
        },
        {
          path: 'new-password-form',
          name: 'new-password-tee',
          component: B2bLoginPasswordFormTee
        }
      ]
    },
    {
      path: '/accionaenergia',
      name: 'loginaccionaenergia',
      component: TheB2bLogin,
      redirect: { name: 'login-form-accionaenergia' },
      children: [
        {
          path: '',
          name: 'login-form-accionaenergia',
          component: B2bLoginFormAccionaEnergia
        },
        {
          path: 'new-password-form',
          name: 'new-password-accionaenergia',
          component: B2bLoginPasswordFormAccionaEnergia
        }
      ]
    },
    {
      path: '/vocento',
      name: 'loginvocento',
      component: TheB2bLogin,
      redirect: { name: 'login-form-vocento' },
      children: [
        {
          path: '',
          name: 'login-form-vocento',
          component: B2bLoginFormVocento
        },
        {
          path: 'new-password-form',
          name: 'new-password-vocento',
          component: B2bLoginPasswordFormVocento
        }
      ]
    },
    {
      path: '/red.es',
      name: 'loginredes',
      component: TheB2bLogin,
      redirect: { name: 'login-form-redes' },
      children: [
        {
          path: '',
          name: 'login-form-redes',
          component: B2bLoginFormRedes
        },
        {
          path: 'new-password-form',
          name: 'new-password-redes',
          component: B2bLoginPasswordFormRedes
        }
      ]
    },    
    {
      path: '/',
      name: 'b2b-app',
      component: TheB2bApp,
      meta: {
        private: true
      },
      children: [
        {
          path: 'profile',
          name: 'profile-page',
          redirect: { name: 'profile-data' },
          component: () => import(/* webpackChunkName: "profile-page" */ '@/views/profile/B2bProfile'),
          meta: {
            breadcrumbTextKey: 'profile_init'
          },
          children: [
            {
              path: '',
              name: 'profile-data',
              component: () => import(/* webpackChunkName: "profile-data" */ '@/views/profile/B2bProfileData'),
              meta: {
                breadcrumbTextKey: 'profile_general_data'
              }
            },
            {
              path: 'password',
              name: 'profile-password',
              component: B2bProfilePassword,
              meta: {
                breadcrumbTextKey: 'profile_password'
              }
            },
            {
              path: 'contact',
              name: 'profile-contact',
              component: B2bProfileContact,
              meta: {
                breadcrumbTextKey: 'profile_media_contact'
              }
            },
            {
              path: 'parties',
              name: 'profile-parties',
              component: B2bPageProfileParties,
              meta: {
                breadcrumbTextKey: 'profile_parties'
              },
              redirect: { name: 'profile-parties-table' },
              children: [
                {
                  path: '',
                  name: 'profile-parties-table',
                  component: B2bProfileParties
                },
                {
                  path: ':partyId',
                  name: 'profile-party',
                  component: B2bRouterView,
                 /* component: () => import( webpackChunkName: "profile-party-detail"  '@/views/profile/B2bPagePartyInfo'),*/
                  meta: {
                    breadcrumbParam: 'partyName'
                  },
                  redirect: { name: 'profile-party-detail'},
                  children: [
                    {
                      path: '',
                      name: 'profile-party-detail',
                      component: () => import( /* webpackChunkName: "profile-party-detail" */ '@/views/profile/B2bPagePartyInfo')
                    },
                    {
                      path: 'centros',
                      name: 'centro-page-profile',
                      component: B2bRouterView,
                      meta: {
                        breadcrumbTextKey: 'administration_project_admin_centres'
                      },
                      redirect: { name: 'table-centres-profile' },
                      children: [
                        {
                          path: '',
                          name: 'table-centres-profile',
                          component: B2bTableCentres
                        },
                        {
                          path: ':centreId',
                          name: 'page-centre-profile',
                          component: B2bPageCentres,
                          meta: {
                            breadcrumbParam: 'centreCode'
                          }
                        },
                      ]
                    }
                  ] 
                },
              ]
            },
            {
              path: 'signature',
              name: 'profile-signature',
              component: B2bProfileSignature,
              meta: {
                breadcrumbTextKey: 'profile_signature'
              }
            }
          ]
        },
        {
          path: 'facturas',
          name: 'facturas-page',
          component: B2bPageFacturas,
          redirect: { name: 'facturas-emitidas-page' },
          children: [
            {
              path: 'emitidas',
              name: 'facturas-emitidas-page',
              component: B2bPageFacturasEmitidas,
              meta: {
                breadcrumbTextKey: 'invoices_emitted'
              },
              redirect: { name: 'facturas-emitidas-table' },
              children: [
                {
                  path: '',
                  name: 'facturas-emitidas-table',
                  component: B2bTableFacturasEmitidas
                },
                {
                  path: 'creacion',
                  name: 'creacion-factura-recepciones-emitidas',
                  component: () => import(/* webpackChunkName: "creacion-factura-recepciones-emitidas" */ '@/views/facturas/creacion/B2bPageCreacionFactura'),
                  meta: {
                    breadcrumbTextKey: 'receptions_new_invoice'
                  }
                },
                {
                  path: ':invoiceNoteId',
                  name: 'factura-emitida-detail',
                  component: B2bPageFacturaEmitida,
                  meta: {
                    breadcrumbParam: 'invoiceNumber'
                  }
                },
                {
                  path: 'creacion',
                  name: 'creacion-factura-facturas-emitidas',
                  component: () => import(/* webpackChunkName: "creacion-factura-facturas-emitidas" */ '@/views/facturas/creacion/B2bPageCreacionFactura'),
                  meta: {
                    breadcrumbTextKey: 'invoices_new_invoice'
                  }
                },
              ]
            },
            {
              path: 'recibidas',
              name: 'facturas-recibidas-page',
              component: B2bPageFacturasRecibidas,
              meta: {
                breadcrumbTextKey: 'invoices_received'
              },
              redirect: { name: 'facturas-recibidas-table' },
              children: [
                {
                  path: '',
                  name: 'facturas-recibidas-table',
                  component: B2bTableFacturasRecibidas
                },
                {
                  path: ':invoiceNoteId',
                  name: 'factura-recibida-detail',
                  component: B2bPageFacturaRecibida,
                  meta: {
                    breadcrumbParam: 'invoiceNumber'
                  }
                }
              ]
            },
            {
              path: 'terceros',
              name: 'facturas-terceros-page',
              component: B2bPageFacturasTerceros,
              meta: {
                breadcrumbTextKey: 'invoices_third'
              },
              redirect: { name: 'facturas-terceros-table' },
              children: [
                {
                  path: '',
                  name: 'facturas-terceros-table',
                  component: () => import(/* webpackChunkName: "terceros-table" */ '@/views/facturas/terceros/B2bTableFacturasTerceros')
                }
              ]
            },
            {
              path: 'borradores',
              name: 'borradores-page',
              component: B2bPageBorradores,
              meta: {
                breadcrumbTextKey: 'invoices_drafts'
              },
              redirect: { name: 'borradores-table' },
              children: [
                {
                  path: '',
                  name: 'borradores-table',
                  component: B2bTableBorradores
                },
                {
                  path: ':draftId',
                  name: 'borrador-detail',
                  component: B2bPageBorrador,
                  meta: {
                    breadcrumbParam: 'invoiceNumber'
                  }
                },
                {
                  path: '',
                  name: 'creacion-factura',
                  component: () => import(/* webpackChunkName: "creacion-factura" */ '@/views/facturas/creacion/B2bPageCreacionFactura'),
                  meta: {
                    breadcrumbTextKey: 'invoices_new_invoice'
                  }
                },
                {
                  path: '',
                  name: 'creacion-factura-borradores-modificacion',
                  component: () => import(/* webpackChunkName: "creacion-factura-borradores-modificacion" */ '@/views/facturas/creacion/B2bPageCreacionFactura'),
                  meta: {
                    breadcrumbTextKey: 'invoices_new_invoice'
                  }
                }
              ]
            },
            {
              path: 'cierrescontables',
              name: 'cierrescontables-page',
              component: B2bPageCierresContables,
              meta: {
                breadcrumbTextKey: 'invoices_accounting_closes'
              },
              redirect: { name: 'cierrescontables-table' },
              children: [
                {
                  path: '',
                  name: 'cierrescontables-table',
                  component: B2bTableCierresContables
                },
                {
                  path: ':draftId',
                  name: 'cierre-detail',
                  component: B2bPageAccountingCloseDrafts,
                  meta: {
                    breadcrumbParam: 'accountingName'
                  }
                }
              ]
            },
            {
              // BORRADORES CIERRES CONTABLES
              path: 'cierrescontables_borradores',
              name: 'borradorescierres-page',
              component: B2bPageAccountingCloseDraft,
              meta: {
                breadcrumbTextKey: 'invoices_draft_accounting_closes'
              },
              redirect: { name: 'borradorescierres-table' },
              children: [
                {
                  path: '',
                  name: 'borradorescierres-table',
                  component: B2bTableAccountingCloseDraft
                },
                {
                  path: 'newaccounting',
                  name: 'new-accounting',
                  component: B2bPageAddAccountingDraft,
                  meta: {
                    breadcrumbTextKey: 'invoices_new_draft_accounting_closes'
                  }
                },
                {
                  path: ':draftId',
                  name: 'borradorcierre-detail',
                  component: B2bPageAddAccountingDraft,
                  meta: {
                    breadcrumbParam: 'accountingName'
                  }
                }
              ]
            },
            {
              // TAREAS PENDIENTES
              path: 'tareaspendientes',
              name: 'tareaspendientes-page',
              component: B2bPagePendingTask,
              meta: {
                breadcrumbTextKey: 'invoices_pending_tasks_title'
              },
              redirect: { name: 'tareaspendientes-table' },
              children: [
                {
                  path: '',
                  name: 'tareaspendientes-table',
                  component: B2bTablePendingTask
                },
                {
                  path: ':invoiceId',
                  name: 'tareaspendientes',
                  component: B2bRouterView,
                  props: true,
                  meta: {
                    breadcrumbParam: 'invoiceNumber'
                  },
                  redirect: { name: 'tareaspendientes-detail' },
                  children: [
                    {
                      path: '',
                      name: 'tareaspendientes-detail',
                      component: B2bPagePendingsTask
                    },
                    {
                      path: 'crear',
                      name: 'create-cover-page',
                      component: B2bRouterView,
                      meta: {
                        breadcrumbTextKey: 'invoices_pending_tasks_cover'
                      },
                      redirect: { name: 'create-cover' },
                      children: [
                        {
                          path: '',
                          name: 'create-cover',
                          component: B2bPageCreateCover,
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              // DOCUMENTOS OCR PENDIENTES DE VALIDAR
              path: 'ocr',
              name: 'ocr-documents-page',
              component: B2bPageOcrDocuments,
              meta: {
                breadcrumbTextKey: 'invoices_ocr' // etiqueta
              },
              redirect: { name: 'documentos-ocr-table' },
              children: [
                {
                  path: '',
                  name: 'documentos-ocr-table',
                  component: B2bTableOcrDocuments
                },
                {
                  path: ':documentId',
                  name: 'page-ocr-document',
                  component: B2bPageOcrDocument,
                  meta: {
                    breadcrumbParam: 'documentName'
                  }
                }
              ]
            }
          ]
        },
        {
          path: 'auditorias',
          name: 'auditorias-page',
          component: B2bPageAuditorias,
          redirect: { name: 'auditorias-documentos-page' },
          children: [
            {
              path: 'documentos',
              name: 'auditorias-documentos-page',
              component: B2bPageAuditoriaDocumentos,
              meta: {
                breadcrumbTextKey: 'auditory_documents'
              },
              redirect: { name: 'auditorias-documentos-table' },
              children: [
                {
                  path: '',
                  name: 'auditorias-documentos-table',
                  component: B2bTableAuditoriaDocumentos
                },
                {
                  path: ':idAuditDocument',
                  name: 'auditoria-documento-detail',
                  component: B2bPageAuditoriaDocumento,
                  props: true,
                  meta: {
                    breadcrumbParam: 'documentNumber'
                  }
                }
              ]
            },
            {
              path: 'acciones',
              name: 'auditorias-acciones-page',
              component: B2bPageAuditoriaAcciones,
              meta: {
                breadcrumbTextKey: 'auditory_actions'
              },
              redirect: { name: 'auditorias-acciones-table' },
              children: [
                {
                  path: '',
                  name: 'auditorias-acciones-table',
                  component: B2bTableAuditoriaAcciones
                }
              ]
            }
          ]
        },
        {
          path: 'recepciones',
          name: 'recadvs-page',
          component: B2bPageRecepciones,
          redirect: { name: 'recadvs-emit-table' },
          children: [
            {
              path: 'emitidas',
              name: 'recadvs-emit-page',
              component: B2bPageRecadvsEmit,
              meta: {
                breadcrumbTextKey: 'receptions_emitted'
              },
              redirect: { name: 'recadvs-emit-table' },
              children: [
                {
                  path: '',
                  name: 'recadvs-emit-table',
                  component: B2bTableRecadvsEmit
                },
                {
                  path: ':recadvId',
                  name: 'recadv-emit-detail',
                  component: B2bPageRecadvsEmits,
                  props: true,
                  meta: {
                    breadcrumbParam: 'recadvNumber'
                  }
                },
                {
                  path: '',
                  name: 'creacionmulti-factura-recepciones-emitidas',
                  component: () => import(/* webpackChunkName: "creacionmulti-factura-recepciones-emitidas" */ '@/views/facturas/creacion/B2bPageCreacionFactura'),
                  meta: {
                    breadcrumbTextKey: 'receptions_new_invoice'
                  }
                }
              ]
            },
            {
              path: 'recibidas',
              name: 'recadvs-received-page',
              component: B2bPageRecadvsReceived,
              meta: {
                breadcrumbTextKey: 'receptions_received'
              },
              redirect: { name: 'recadvs-received-table' },
              children: [
                {
                  path: '',
                  name: 'recadvs-received-table',
                  component: B2bTableRecadvsReceived
                },
                {
                  path: ':recadvId',
                  name: 'recadv-received-detail',
                  component: B2bPageRecadvsReceiveds,
                  props: true,
                  meta: {
                    breadcrumbParam: 'recadvNumber'
                  }
                },
                {
                  path: 'creacion',
                  name: 'creacion-factura-recepciones-recibidas',
                  component: () => import(/* webpackChunkName: "creacion-factura-recepciones-recibidas" */ '@/views/facturas/creacion/B2bPageCreacionFactura'),
                  meta: {
                    breadcrumbTextKey: 'receptions_new_invoice'
                  }
                },
                {
                  path: '',
                  name: 'creacionmulti-factura-recepciones-recibidas',
                  component: () => import(/* webpackChunkName: "creacionmulti-factura-recepciones-recibidas" */ '@/views/facturas/creacion/B2bPageCreacionFactura'),
                  meta: {
                    breadcrumbTextKey: 'receptions_new_invoice'
                  }
                }
              ]
            }
          ]
        },
        {
          path: 'albaranes',
          name: 'delivery-notes-page',
          component: B2bPageDeliveryNotes,
          redirect: { name: 'delivery-notes-emit-table' },
          children: [
            {
              path: 'emitidos',
              name: 'delivery-notes-emit-page',
              component: B2bPageDeliveryNotesEmit,
              meta: {
                breadcrumbTextKey: 'delivery_notes_emitted'
              },
              redirect: { name: 'delivery-notes-emit-table' },
              children: [
                {
                  path: '',
                  name: 'delivery-notes-emit-table',
                  component: B2bTableDeliveryNotesEmit
                },
                {
                  path: ':deliveryId',
                  name: 'delivery-note-emit-detail',
                  component: B2bPageDeliveryNotesEmits,
                  props: true,
                  meta: {
                    breadcrumbParam: 'deliveryNumber'
                  }
                },
                {
                  path: 'creacion',
                  name: 'creacion-factura-albaranes-emitidos',
                  component: () => import(/* webpackChunkName: "creacion-factura-albaranes-emitidos" */ '@/views/facturas/creacion/B2bPageCreacionFactura'),
                  meta: {
                    breadcrumbTextKey: 'deliverynote_new_invoice'
                  }
                },
                {
                  path: '',
                  name: 'creacion-factura-albaranes-emitidos',
                  component: () => import(/* webpackChunkName: "creacion-factura-albaranes-emitidos" */ '@/views/facturas/creacion/B2bPageCreacionFactura'),
                  meta: {
                    breadcrumbTextKey: 'deliverynote_new_invoice'
                  }
                },
              ]
            },
            {
              path: 'recibidos',
              name: 'delivery-notes-received-page',
              component: B2bPageDeliveryNotesReceived,
              meta: {
                breadcrumbTextKey: 'delivery_notes_received'
              },
              redirect: { name: 'delivery-notes-received-table' },
              children: [
                {
                  path: '',
                  name: 'delivery-notes-received-table',
                  component: B2bTableDeliveryNotesReceived
                },
                {
                  path: ':deliveryId',
                  name: 'delivery-note-received-detail',
                  component: B2bPageDeliveryNotesReceiveds,
                  props: true,
                  meta: {
                    breadcrumbParam: 'deliveryNumber'
                  }
                }
              ]
            }
          ]
        },
        {
          path: 'cmr',
          name: 'cmr-page',
          component: B2bPageCMR,
          redirect: { name: 'cmr-table' },
          children: [
            {
              path: 'emitidos',
              name: 'cmr-page',
              component: B2bPageCMREmit,
              meta: {
                breadcrumbTextKey: 'cmr_init'
              },
              redirect: { name: 'cmr-table' },
              children: [
                {
                  path: '',
                  name: 'cmr-table',
                  component: B2bTableCMR
                },
                {
                  path: ':cmrId',
                  name: 'cmr-detail',
                  component: B2bPageCMREmits,
                  props: true,
                  meta: {
                    breadcrumbParam: 'cmrNumber'
                  }
                }
              ]
            }           
          ]
        },
        {
          path: 'pedidos',
          name: 'orders-page',
          component: B2bPagePedidos,
          redirect: { name: 'orders-emit-table' },
          children: [
            {
              path: 'emitidos',
              name: 'orders-emit-page',
              component: B2bPageOrdersEmit,
              meta: {
                breadcrumbTextKey: 'orders_emitted'
              },
              redirect: { name: 'orders-emit-table' },
              children: [
                {
                  path: '',
                  name: 'orders-emit-table',
                  component: B2bTableOrdersEmit
                },
                {
                  path: ':orderId',
                  name: 'order-emit-detail',
                  component: B2bPageOrdersEmits,
                  props: true,
                  meta: {
                    breadcrumbParam: 'orderNumber'
                  }
                }
              ]
            },
            {
              path: 'recibidos',
              name: 'orders-received-page',
              component: B2bPageOrdersReceived,
              meta: {
                breadcrumbTextKey: 'orders_received'
              },
              redirect: { name: 'orders-received-table' },
              children: [
                {
                  path: '',
                  name: 'orders-received-table',
                  component: B2bTableOrdersReceived
                },
                {
                  path: ':orderId',
                  name: 'order-received-detail',
                  component: B2bPageOrdersReceiveds,
                  props: true,
                  meta: {
                    breadcrumbParam: 'orderNumber'
                  }
                },
                {
                  path: 'creacion',
                  name: 'creacion-factura-pedidos-recibidos',
                  component: () => import(/* webpackChunkName: "creacion-factura-pedidos-recibidos" */ '@/views/facturas/creacion/B2bPageCreacionFactura'),
                  meta: {
                    breadcrumbTextKey: 'orders_new_invoice'
                  }
                },
                {
                  path: '',
                  name: 'creacion-factura-pedidos-recibidas',
                  component: () => import(/* webpackChunkName: "creacion-factura-pedidos-recibidas" */ '@/views/facturas/creacion/B2bPageCreacionFactura'),
                  meta: {
                    breadcrumbTextKey: 'orders_new_invoice'
                  }
                },,
                {
                  path: '',
                  name: 'creacion-albaran-pedidos-recibidos',
                  component: () => import(/* webpackChunkName: "creacion-albaran" */ '@/views/albaranes/creacion/B2bPageCreacionAlbaran'),
                  meta: {
                    breadcrumbTextKey: 'orders_new_deliveryNote'
                  }
                },
                {
                  path: '',
                  name: 'creacion-albaran-modificacion',
                  component: () => import(/* webpackChunkName: "creacion-albaran-modificacion" */ '@/views/albaranes/creacion/B2bPageCreacionAlbaran'),
                  meta: {
                    breadcrumbTextKey: 'orders_new_deliveryNote'
                  }
                }
              ]
            }
          ]
        },
        {
          path: 'genrals',
          name: 'genrals-page',
          component: B2bPageGenrals,
          redirect: { name: 'genrals-emit-table' },
          children: [
            {
              path: 'emitidos',
              name: 'genrals-emit-page',
              component: B2bPageGenralsEmit,
              meta: {
                breadcrumbTextKey: 'genrals_emitted'
              },
              redirect: { name: 'genrals-emit-table' },
              children: [
                {
                  path: '',
                  name: 'genrals-emit-table',
                  component: B2bTableGenralsEmit
                },
                {
                  path: ':genralId',
                  name: 'genral-emit-detail',
                  component: B2bPageGenralsEmits,
                  props: true,
                  meta: {
                    breadcrumbParam: 'genralNumber'
                  }
                }
              ]
            },
            {
              path: 'recibidos',
              name: 'genrals-received-page',
              component: B2bPageGenralsReceived,
              meta: {
                breadcrumbTextKey: 'genrals_received'
              },
              redirect: { name: 'genrals-received-table' },
              children: [
                {
                  path: '',
                  name: 'genrals-received-table',
                  component: B2bTableGenralsReceived
                },
                {
                  path: ':genralId',
                  name: 'genral-received-detail',
                  component: B2bPageGenralsReceiveds,
                  props: true,
                  meta: {
                    breadcrumbParam: 'genralNumber'
                  }
                }
              ]
            }
          ]
        },
        {
          path: 'administracion',
          name: 'administration-page',
          component: B2bPageAdministracion,
          redirect: { name: 'servicios-page' },
          children: [
            {
              path: 'servicios',
              name: 'servicios-page',
              component: B2bRouterView,
              meta: {
                breadcrumbTextKey: 'administration_project_projects'
              },
              redirect: { name: 'servicios-table' },
              children: [
                {
                  path: '',
                  name: 'servicios-table',
                  component: B2bTableServicios
                },
                {
                  path: 'newservice',
                  name: 'new-service',
                  component: B2bPageAddServices,
                  meta: {
                    breadcrumbTextKey: 'administration_project_add_project'
                  }
                },
                {
                  path: ':projectId',
                  name: 'parties-service',
                  component: B2bRouterView,
                  props: true,
                  meta: {
                    breadcrumbParam: 'projectName'
                  },
                  redirect: { name: 'service-detail' },
                  children: [
                    {
                      path: '',
                      name: 'service-detail',
                      component: B2bPageServicio
                    },
                    {
                      path: 'empresas',
                      name: 'servicios-empresas-page',
                      component: B2bRouterView,
                      meta: {
                        breadcrumbTextKey: 'administration_project_projectparties'
                      },
                      redirect: { name: 'servicios-empresas-table' },
                      children: [
                        {
                          path: '',
                          name: 'servicios-empresas-table',
                          component: B2bTableServiciosEmpresas
                        },
                        {
                          path: 'newparty',
                          name: 'new-party-page',
                          component: B2bRouterView,
                          meta: {
                            breadcrumbTextKey: 'administration_project_add_party'
                          },
                          redirect: { name: 'new-parties-service-country-nif' },
                          children: [
                            {
                              path: '',
                              name: 'new-parties-service-country-nif',
                              component: B2bPageAddPartiesServicesCountryNif
                            },
                            {
                              path: 'details',
                              name: 'new-parties-service',
                              component: B2bPageAddPartiesService
                            }
                          ]
                        },
                        {
                          path: ':partyId',
                          name: 'party-page',
                          component: B2bRouterView,
                          meta: {
                            breadcrumbParam: 'partyName'
                          },
                          redirect: { name: 'party-detail' },
                          children: [
                            {
                              path: '',
                              name: 'party-detail',
                              component: B2bPagePartiesServices
                            },
                            {
                              path: 'relation',
                              name: 'commercial-relation-page',
                              component: B2bRouterView,
                              meta: {
                                breadcrumbTextKey: 'administration_project_admin_channels'
                              },
                              redirect: { name: 'commercial-relation' },
                              children: [
                                {
                                  path: '',
                                  name: 'commercial-relation',
                                  component: B2bTableCommercialRelation
                                },
                                {
                                  path: 'partycommercialrelationId',
                                  name: 'page-comertial-relation',
                                  component: B2bPageCommercialRelation,
                                  meta: {
                                    breadcrumbTextKey: 'administration_project_admin_channels_detail'
                                  }
                                }
                              ]
                            },
                            {
                              path: 'centros',
                              name: 'centro-page',
                              component: B2bRouterView,
                              meta: {
                                breadcrumbTextKey: 'administration_project_admin_centres'
                              },
                              redirect: { name: 'table-centres' },
                              children: [
                                {
                                  path: '',
                                  name: 'table-centres',
                                  component: B2bTableCentres
                                },
                                {
                                  path: ':centreId',
                                  name: 'page-centre',
                                  component: B2bPageCentres,
                                  meta: {
                                    breadcrumbParam: 'centreCode'
                                  }
                                },
                                {
                                  path: 'newcentre',
                                  name: 'page-add-centre',
                                  component: B2bPageAddCentre,
                                  meta: {
                                    breadcrumbTextKey: 'administration_project_add_centre'
                                  }
                                },
                                {
                                  path: 'approvalflow/:centreId',
                                  name: 'page-approval-flows',
                                  component: B2bRouterView,
                                  meta: {
                                    breadcrumbParam: 'centreCode'
                                  },
                                  redirect: { name: 'table-approval-flow' },
                                  children: [
                                    {
                                      path: '',
                                      name: 'table-approval-flow',
                                      component: B2bPageApprovalFlows
                                    },
                                    {
                                      path: ':centreApprovalAmountId',
                                      name: 'page-approval-flow',
                                      component: B2bPageApprovalFlowByLevels,
                                      meta: {
                                        breadcrumbParam: 'centreApprovalAmountId'
                                      },
                                    },
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              path: 'empresas',
              name: 'empresas-page',
              component: B2bRouterView,
              meta: {
                breadcrumbTextKey: 'administration_party_parties'
              },
              redirect: { name: 'empresas-table' },
              children: [
                {
                  path: '',
                  name: 'empresas-table',
                  component: B2bTableServiciosEmpresas,
                },
                {
                  path: ':partyId',
                  name: 'onlyparty-page',
                  component: B2bRouterView,
                  meta: {
                    breadcrumbParam: 'partyName'
                  },
                  redirect: { name: 'onlyparty-detail' },
                  children: [
                    {
                      path: '',
                      name: 'onlyparty-detail',
                      component: B2bPagePartiesServices
                    },
                    {
                      path: 'centros',
                      name: 'centro-page-party',
                      component: B2bRouterView,
                      meta: {
                        breadcrumbTextKey: 'administration_project_admin_centres'
                      },
                      redirect: { name: 'table-centres-party' },
                      children: [
                        {
                          path: '',
                          name: 'table-centres-party',
                          component: B2bTableCentres
                        },
                        {
                          path: ':centreId',
                          name: 'page-centre-party',
                          component: B2bPageCentres,
                          meta: {
                            breadcrumbParam: 'centreCode'
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              path: 'usuarios',
              name: 'usuarios-page',
              component: B2bPageUsuarios,
              meta: {
                breadcrumbTextKey: 'administration_users'
              },
              redirect: { name: 'usuarios-table' },
              children: [
                {
                  path: '',
                  name: 'usuarios-table',
                  component: B2bTableUsuarios
                },
                {
                  path: ':userId',
                  name: 'usuario-detail',
                  component: B2bPageUsuario,
                  props: true,
                  meta: {
                    breadcrumbParam: 'username'
                  }
                },
                {
                  path: 'crear',
                  name: 'createuser',
                  component: () => import(/* webpackChunkName: "createuser" */ '@/views/administracion/usuarios/createuser/B2bPageCreateUser'),
                  props: true,
                  meta: {
                    breadcrumbTextKey: 'administration_users_add_user'
                  },
                  redirect: { name: 'new-user' },
                  children: [
                    {
                      path: 'nuevo',
                      name: 'new-user',
                      component: B2bNewUser,
                      props: true
                    },
                    {
                      path: 'datos',
                      name: 'data-user',
                      component: B2bNewUserData,
                      props: true
                    },
                    {
                      path: 'entidades',
                      name: 'entities-user',
                      component: B2bNewUserEntities
                    },
                    {
                      path: 'permisos',
                      name: 'permissions-user',
                      component: B2bNewUserPermissions
                    },
                    {
                      path: 'empresa',
                      name: 'cif-party',
                      component: B2bNewUserCif
                    },
                    {
                      path: 'datos',
                      name: 'data-userexist',
                      component: B2bNewUserExistData
                    },
                    {
                      path: 'entidades',
                      name: 'entities-userexist',
                      component: B2bNewUserExistEntities,
                      props: true
                    },
                    {
                      path: 'permisos',
                      name: 'permissions-userexist',
                      component: B2bNewUserExistPermissions,
                      props: true
                    }
                  ]
                }
              ]
            },
            {
              path: 'profiles',
              name: 'profiles-page',
              component: B2bRouterView,
              meta: {
                breadcrumbTextKey: 'administration_profiles'
              },
              redirect: { name: 'profiles-table' },
              children: [
                {
                  path: '',
                  name: 'profiles-table',
                  component: B2bTableProfiles
                },
                {
                  path: ':profileId',
                  name: 'profile-detail',
                  component: () => import(/* webpackChunkName: "createuser" */ '@/views/administracion/profiles/B2bPageProfile'),
                  props: true,
                  meta: {
                    breadcrumbParam: 'profilename'
                  }
                },
                {
                  path: 'nuevo',
                  name: 'profile-new',
                  component: () => import(/* webpackChunkName: "profile-new" */ '@/views/administracion/profiles/B2bPageProfile'),
                  props: true,
                  meta: {
                    breadcrumbTextKey: 'administration_new'
                  }
                }
              ]
            },
            {
              path: 'plannedProcesses',
              name: 'plannedProcesses-page',
              component: B2bPagePlannedProcesses,
              meta: {
                breadcrumbTextKey: 'administration_plannedProcesses'
              },
              redirect: { name: 'plannedProcesses-table' },
              children: [
                {
                  path: '',
                  name: 'plannedProcesses-table',
                  component: B2bTablePlannedProcesses,
                }
              ]
            },
            {
              path: 'taxes',
              name: 'taxes-page',
              component: B2bRouterView,
              meta: {
                breadcrumbTextKey: 'administration_taxes'
              },
              redirect: { name: 'taxes-table' },
              children: [
                {
                  path: '',
                  name: 'taxes-table',
                  component: B2bTableTaxes
                },
                {
                  path: ':taxId',
                  name: 'tax-detail',
                  component: B2bPageTax,
                  props: true,
                  meta: {
                    breadcrumbParam: 'taxname'
                  }
                },
                {
                  path: 'nuevo',
                  name: 'tax-new',
                  component: B2bPageTax,
                  props: true,
                  meta: {
                    breadcrumbTextKey: 'administration_new'
                  }
                }
              ]
            },
            {
              path: 'plantillasDeCorreo',
              name: 'plantillas-de-correo-page',
              component: B2bRouterView,
              meta: {
                breadcrumbTextKey: 'administration_mailTemplates'
              },
              redirect: { name: 'plantillas-de-correo-table' },
              children: [
                {
                  path: '',
                  name: 'plantillas-de-correo-table',
                  component: () => import(/* webpackChunkName: "plantillas-de-correo-table" */ '@/views/administracion/plantillasDeCorreo/B2bTablePlantillasDeCorreo')
                },
                {
                  path: ':mailTemplateId',
                  name: 'mailTemplate-detail',
                  component: () => import(/* webpackChunkName: "mailTemplate-detail" */ '@/views/administracion/plantillasDeCorreo/B2bPagePlantillaDeCorreo'),
                  props: true,
                  meta: {
                    breadcrumbParam: 'mailTemplateType'
                  }
                }
              ]
            },
            {
              path: 'mailServer',
              name: 'mailServer-page',
              component: B2bRouterView,
              meta: {
                breadcrumbTextKey: 'administration_mailServer'
              },
              redirect: { name: 'mailServer-table' },
              children: [
                {
                  path: '',
                  name: 'mailServer-table',
                  component: B2bTableMailServers
                },
                {
                  path: ':mailServerId',
                  name: 'mailServer-detail',
                  component: B2bPageMailServer,
                  props: true,
                  meta: {
                    breadcrumbParam: 'host'
                  }
                },
                {
                  path: 'nuevo',
                  name: 'mailServer-new',
                  component: B2bPageMailServer,
                  props: true,
                  meta: {
                    breadcrumbTextKey: 'administration_mailServer_add_new'
                  }
                }
              ]
            }
          ]
        },
        {
          path: 'issues',
          name: 'issues-page',
          component: B2bPageIssues,
          meta: {
            breadcrumbTextKey: 'issues_issues'
          },
          redirect: { name: 'issues-table' },
          children: [
            {
              path: '',
              name: 'issues-table',
              component: B2bTableIssues
            },
            {
              path: ':issueId',
              name: 'issue-detail',
              component: B2bPageIssue,
              props: true,
              meta: {
                breadcrumbParam: 'summary'
              }
            },
            {
              path: 'crear',
              name: 'issue-detail',
              component: B2bPageIssue,
              props: true,
              meta: {
                breadcrumbTextKey: 'issues_add_issue'
              }
            }
          ]
        },
        {
          path: 'documentacion',
          name: 'documentacion-page',
          component: B2bPageDocumentacion,
          redirect: { name: 'documentacion-documentos-page' },
          children: [
            {
              path: 'documentos',
              name: 'documentacion-documentos-page',
              component: B2bPageDocumentacionDocumentos,
              meta: {
                breadcrumbTextKey: 'documentation_documents'
              },
              redirect: { name: 'documentacion-documentos-table' },
              children: [
                {
                  path: '',
                  name: 'documentacion-documentos-table',
                  component: B2bTableDocumentacionDocumentos
                },
                {
                  path: ':idDocumentation',
                  name: 'documentacion-documento-detail',
                  component: B2bPageDocumentacionDocumento,
                  props: true,
                  meta: {
                    breadcrumbParam: 'documentationName'
                  }
                }
              ]
            }
          ]
        },
        {
          path: 'statistics',
          name: 'estadistica-page',
          component: B2bPageEstadisticas,
          redirect: { name: 'statistic-emitted-page' },
          children: [
            {
              path: 'statisticsEmitted',
              name: 'statistic-emitted-page',
              component: B2bPageEstadisticasEmitidas,
              meta: {
                breadcrumbTextKey: 'statistic_emitted'
              }
            },
            {
              path: 'statisticsReceived',
              name: 'statistic-received-page',
              component: B2bPageEstadisticasRecibidas,
              meta: {
                breadcrumbTextKey: 'statistic_received'
              }
            },
            {
              path: 'statisticsOther',
              name: 'statistic-other-page',
              component: B2bPageEstadisticasOtras,
              meta: {
                breadcrumbTextKey: 'statistic_other'
              }
            },
            {
              path: 'statisticsTopSeller',
              name: 'statistic-topseller-page',
              component: B2bPageEstadisticasTopSeller,
              meta: {
                breadcrumbTextKey: 'statistic_topseller'
              }
            },
            {
              path: 'statisticsParties',
              name: 'statistic-parties-page',
              component: B2bPageEstadisticasEmpresas,
              meta: {
                breadcrumbTextKey: 'statistic_parties'
              }
            },
            {
              path: 'statisticsRejected',
              name: 'statistic-rejected-page',
              component: B2bPageEstadisticasRechazadas,
              meta: {
                breadcrumbTextKey: 'statistic_rejected'
              }
            }
          ]
        }
      ]
    },
    {
      path: '*',
      redirect: { name: 'facturas-emitidas-page' }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

// Config Protected Routes Global
route.beforeEach((to, from, next) => {
  /* if (process.env.NODE_ENV === 'development' && appStore.state.login.forceThemeMods) {
    appStore.dispatch('writeThemeColors')
  } */
  let redirect = to.redirectedFrom
  let toname = to.name

  let routePrivate = null
  let store = null
  let userLocalActive = null

  if((redirect && redirect.toLowerCase().indexOf('link') !== -1) || (toname && toname.toLowerCase().indexOf('link') !== -1)){
    next()
    return
  }
  if (localStorage.getItem('store') === null) {
    next()
  } else {
    store = JSON.parse(localStorage.getItem('store'))
    userLocalActive = store.session.activeUser.isActive
    routePrivate = to.matched.some(record => record.meta.private)
    next()
  }

  if (routePrivate && userLocalActive) {
    next()
  } else if (routePrivate) {
    next({ name: 'login' })
  } else {
    setBreadcrumbParams(to)
    next()
  }
})
export const setBreadcrumbParams = to => {
  const breadcrumbParams = { // este es el objeto a personalizar según las necesidades del proyectos
    projectName: sessionStorage.getItem('projectName'), // en este ejemplo usamos el sessionSorage para recuperar datos
    partyName: sessionStorage.getItem('partyName'),
    centreCode: sessionStorage.getItem('centreCode'),
    username: sessionStorage.getItem('username'),
    documentNumber: sessionStorage.getItem('documentNumber'),
    accountingName: sessionStorage.getItem('accountingName'),
    documentationName: sessionStorage.getItem('documentationName'),
    invoiceNumber: sessionStorage.getItem('invoiceNumber'),
    recadvNumber: sessionStorage.getItem('recadvNumber'),
    orderNumber: sessionStorage.getItem('orderNumber'),
    genralNumber: sessionStorage.getItem('genralNumber'),
    partycommercialrelationId: sessionStorage.getItem('partycommercialrelationId'),
    mailTemplateType: sessionStorage.getItem('mailTemplateType')

  }
  to.matched.forEach(e => {
    for (const param in breadcrumbParams) {
      if (e.meta.breadcrumbParam === param) {
        to.params[e.meta.breadcrumbParam] = breadcrumbParams[param]
      }
    }
  })
}

export default route
